import { CancelToken } from 'axios';
import { http } from '../helpers/axiosHelper';
export default class StepRequirementService {
   async getStepRequirementsOptions(stepId: Number, cancelToken?: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/step/${stepId}/requirement-options`, { cancelToken: cancelToken })
         .then((response) => {
            return response.data;
         });
   }

   async getStepRequirements(stepId: Number, cancelToken?: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/step/${stepId}/requirements`, {
            cancelToken: cancelToken,
            params: { include: 'requirements.tags' },
         })
         .then((response) => {
            return response.data;
         });
   }

   async postRequirement(stepId: Number, sequence: Number) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/requirement`, { step_id: stepId, sequence: sequence })
         .then((response) => {
            return response.data;
         });
   }

   async deleteRequirement(requirementId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/requirement/${requirementId}`).then((response) => {
         return response.data;
      });
   }

   async postRequirementTag(requirementId: Number, tagId: Number, sequence: Number) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/requirement-tag`, {
            requirement_id: requirementId,
            tag_id: tagId,
            sequence: sequence,
         })
         .then((response) => {
            return response.data;
         });
   }

   async patchRequirementTag(requirementTagId: Number, body: Object) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/requirement-tag/${requirementTagId}`, [body])
         .then((response) => {
            return response.data;
         });
   }

   async deleteRequirementTag(requirementTagId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/requirement-tag/${requirementTagId}`).then((response) => {
         return response.data;
      });
   }
}
